import React from 'react';

class FormFilled extends React.Component {
    render() {
        const { theMessage } = this.props;

        return(
            <div className="col-12 alert alert-info px-3">
                {/* if theMessage contains substring "Anopheles stephensi", make "Anopheles stephensi" italic*/}
                {theMessage.includes("Anopheles stephensi") ? (
                    <span>
                        {theMessage.substring(0, theMessage.indexOf("Anopheles stephensi"))}
                        <i>Anopheles stephensi</i>
                        {theMessage.substring(theMessage.indexOf("Anopheles stephensi") + 19)}
                    </span>
                ) : (
                    <span>{theMessage}</span>
                )}
            </div>
        )
    }
}

export default FormFilled;